import { render, staticRenderFns } from "./TheWizardFooter.vue?vue&type=template&id=54abcc3f&scoped=true&"
import script from "./TheWizardFooter.vue?vue&type=script&lang=js&"
export * from "./TheWizardFooter.vue?vue&type=script&lang=js&"
import style0 from "./TheWizardFooter.vue?vue&type=style&index=0&id=54abcc3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54abcc3f",
  null
  
)

export default component.exports